/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ number: NonNullable<unknown> }} Galleryopenimage2Inputs */

const en_galleryopenimage2 = /** @type {(inputs: Galleryopenimage2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Open image ${i?.number}`)
};

const de_galleryopenimage2 = /** @type {(inputs: Galleryopenimage2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bild ${i?.number} öffnen`)
};

/**
* | output |
* | --- |
* | "Open image {number}" |
*
* @param {Galleryopenimage2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const galleryopenimage2 = /** @type {((inputs: Galleryopenimage2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Galleryopenimage2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_galleryopenimage2(inputs)
	return de_galleryopenimage2(inputs)
});
export { galleryopenimage2 as "galleryOpenImage" }